<template>
  <div :class="['carousel-section', className]">
    <VSkeletonLoader
      v-if="loading"
      type="image"
      height="400"
    />
    <ProductCarousel
      v-else-if="products.length > 0"
      :products="products"
      :source="AddToCartSource.CMS_CONTENT"
      hide-wishlist
    />
  </div>
</template>

<script setup lang="ts">
import ProductCarousel from '~/components/base/ProductCarousel.vue'
import { AddToCartSource } from '~/stores/cart'
import type { ProductAPIResponse } from '~/types/shop'

interface Props {
  products?: ProductAPIResponse[]
  loading?: boolean
  className?: string
}

withDefaults(defineProps<Props>(), {
  products: () => [],
  loading: false,
  className: undefined
})
</script>

<style lang="scss" scoped>
.carousel-section {
  margin: 24px 0;
}
</style>
